<script>
export default {
  name: "/"
}
</script>

<template>
  <div class="cost-services reinvest left mobile">
    <h1 class="left flex flex-xy-center">Стоимость услуг</h1>
    <div class="cost-cards-container left flex flex-x-center">
      <div class="cost-card left flex flex-xy-center flex-column">
        <span class="price-desc">Подбор инвестиционного объекта недвижимости в подходящем под заданные цели ЖК</span>
        <span class="price-invest">125.000 рублей</span>
      </div>

      <div class="cost-card left flex flex-xy-center flex-column">
        <span class="price-desc">Отчет о проверке объекта городской недвижимости и его собственника</span>
        <span class="price-invest">80.000 рублей</span>
      </div>

      <div class="cost-card other-margin left flex flex-xy-center flex-column mobile-nv">
        <span class="price-desc">Покупка/продажа квартиры/апартамента (организационное и юридическое сопровождение сделки</span>
        <span class="price-invest other-margin"> 1.5 %от стоимости<br>объекта,<br>но не менее<br>135.000 рублей</span>
      </div>
      <span class="disclaimer-price mobile-nv">*Отчет о проверке объекта городской недвижимости и его собственника*Отчет о проверке объекта городской недвижимости и его собственника*Отчет о проверке объекта городской недвижимости и его собственника</span>
      <svg class="green-path mobile-nv" width="1920" height="435" viewBox="0 0 1920 435" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M-50 2C-39.3333 104.333 42.7 320.9 285.5 368.5C589 428 696 274.5 937 284C1178 293.5 1387.5 409.5 1572.5 422C1720.5 432 1895.17 292.5 1964 221.5" stroke="#B2DBBF" stroke-width="24"/>
      </svg>

    </div>
    <div class="cost-card other-margin left flex flex-xy-center flex-column mobile">
      <span class="price-desc">Покупка/продажа квартиры/апартамента (организационное и юридическое сопровождение сделки</span>
      <span class="price-invest other-margin mobile-nv"> 1.5 %от стоимости<br>объекта,<br>но не менее<br>135.000 рублей</span>
      <span class="price-invest other-margin mobile"> 1.5 %от стоимости объекта, но не менее 135.000 рублей</span>
    </div>
    <div class="cost-card other-margin reinvest left flex flex-xy-center flex-column mobile">
      <span class="price-desc">Помощь в выгодной продаже имеющихся обьектов недвижимости с последующим инвестированием средств в более перспективные объекты (при комплексной сделке продажа+покупка)</span>
      <span class="price-invest other-margin mobile-nv"> 1.5 %от стоимости<br>объекта,<br>но не менее<br>135.000 рублей</span>
      <span class="price-invest other-margin mobile"> 1% от цены продаваемого объекта недвижимости, но не менее 110.000руб, подбор 100.000, покупка 1%, но не менее 110.000 рублей.
</span>
    </div>
    <span class="disclaimer-price mobile-nv">*Отчет о проверке объекта городской недвижимости и его собственника*Отчет о проверке объекта городской недвижимости и его собственника*Отчет о проверке объекта городской недвижимости и его собственника</span>


  </div>
</template>

<style scoped>

</style>